<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="showErrorDias" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a
          {{ this.dias }} dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showErrorDias = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container style="background-color: #f8f9fb">
      <!-- Banner Informativo: Ordem e Guia de Uso da Consulta GLPI -->
      <v-row class="mb-0">
        <v-col cols="12" class="pb-1">
          <v-alert
            type="info"
            text
            dense
            icon="mdi-information-outline"
            class="mb-2"
          >
            <div class="d-flex align-center flex-wrap" style="font-size: 13px;">
              <span class="font-weight-bold mr-2">Ordem de uso:</span>
              <span><strong>1º</strong> Selecione a Empresa</span>
              <v-icon small color="info" class="mx-1">mdi-arrow-right</v-icon>
              <span><strong>2º</strong> Selecione a Entidade</span>
              <v-icon small color="info" class="mx-1">mdi-arrow-right</v-icon>
              <span><strong>3º</strong> Defina o Período</span>
              <v-icon small color="info" class="mx-1">mdi-arrow-right</v-icon>
              <span><strong>4º</strong> Clique em <strong>Filtrar</strong></span>
            </div>
          </v-alert>
        </v-col>
      </v-row>

      <v-col cols="12" class="pt-0">
        <FiltroGLPI
          calendar="mes"
          :valueStartISO="dataInicio"
          :valueEndISO="dataFim"
          :entidadeMasterOptions="entidadeMasterOptions"
          :relacionamentoSubOptions="filteredEmpresas"
          :ticSubOptions="ticSubOptions"
          :valueEntidadeMaster="entidadeMasterSelecionada"
          :valueRelacionamento="relacionamentoSubSelecionada"
          :valueTic="ticSubSelecionada"
          @filtrar="onFiltroFiltrar"
          @limpar="onFiltroLimpar"
        />
      </v-col>
    </v-container>
    <v-container style="background-color: #f8f9fb">
      <v-row>
        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="rgb(71 130 180)"
            icon="mdi-cash"
            title="Total de Chamados"
            sub-icon-color="blue"
            :valuex="false"
            subIcon="mdi-information"
            :value="String(resumo.totalChamados || 0)"
            :sub-text="'Total de chamados no periodo'"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="rgb(71 130 180)"
            icon="mdi-cash"
            title="Chamados Solucionados"
            sub-icon-color="blue"
            :valuex="false"
            subIcon="mdi-information"
            :value="String(resumo.chamadosSolucionados || 0)"
            :sub-text="'Total de chamados solucionados no periodo'"
          />
        </v-col>

        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="rgb(71 130 180)"
            icon="mdi-cash"
            title="Média de Tempo por Ticket"
            sub-icon-color="blue"
            :valuex="false"
            subIcon="mdi-information"
            :value="String(resumo.mediaTempoPorTicket || 0)"
            :sub-text="'Média de tempo por ticket no periodo'"
          />
        </v-col>
      </v-row>
    </v-container>
    <br />
    <v-divider class="mx-12" />
    <br />
    <v-container fluid tag="section" style="background-color: #eee">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-chart-bar"
            title="Chamados por Mês"
            color="green"
            class="px-5 py-0"
          >
            <div class="chart-box">
              <apexchart
                type="bar"
                height="300"
                :options="chartOptionsChamados"
                :series="chartSeriesChamados"
              />
            </div>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-chart-bar"
            title="Chamados Solucionados por Mês"
            color="blue"
            class="px-5 py-0"
          >
            <div class="chart-box">
              <apexchart
                type="bar"
                height="300"
                :options="chartOptionsSolucionados"
                :series="chartSeriesSolucionados"
              />
            </div>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-chart-bar"
            title="Tempo de Resolução (média horas por ticket)"
            color="orange"
            class="px-5 py-0"
          >
            <div class="chart-box">
              <apexchart
                type="bar"
                height="300"
                :options="chartOptionsTempoResolucao"
                :series="chartSeriesTempoResolucao"
              />
            </div>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="18">
          <base-material-card
            icon="mdi-shape"
            title="TOP chamados abertos por Categoria"
            color="green"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="headersAbertos"
              :items="abertosFiltrado"
              :items-per-page="5"
              items-per-page-text="Linhas por página"
              class="elevation-0"
              :loading="isLoading"
            >
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 12%; font-size: 14px">
                    {{ formatPeriodo(row.item.periodo) }}
                  </td>
                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ decodeHtml(row.item.completename) }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.qtd }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="18">
          <base-material-card
            icon="mdi-check-decagram"
            title="Solucionados / Fechados"
            color="blue"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="headersSolucionados"
              :items="solucionadosFiltrado"
              :items-per-page="5"
              items-per-page-text="Linhas por página"
              class="elevation-0"
              :loading="isLoading"
            >
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 12%; font-size: 14px">
                    {{ formatPeriodo(row.item.periodo) }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.quantidade }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="18">
          <base-material-card
            icon="mdi-timer-sand"
            title="Tempo de Resolução"
            color="orange"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="headersTempo"
              :items="tempoFiltrado"
              :items-per-page="5"
              items-per-page-text="Linhas por página"
              class="elevation-0"
              :loading="isLoading"
            >
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ row.item.completename }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ formatPeriodo(row.item.periodo) }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.totalTicket }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.totalHoras }}
                  </td>
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.mediaHorasTickets }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Glpi from "@/services/glpi";
import FiltroGLPI from "@/views/dashboard/components/FiltroGLPI";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "ConsultaGLPI",
  components: {
    FiltroGLPI,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      entityId: null,
      isLoading: false,
      // seleção de entidade (lista única)
      entidadeMasterOptions: [
        { text: "TI", value: "TIC" },
        { text: "Marketing", value: 3 },
        { text: "RH", value: 4 },
        { text: "Administrativo & Manutenção", value: 5 },
        { text: "Contratos & Faturamento", value: 9 },
        { text: "Regulação de Seguros", value: 10 },
        { text: "Financeiro", value: 11 },
        { text: "LGPD & Segurança da Informação", value: 12 },
        { text: "Projetos", value: 13 },
        { text: "Qualidade & Processos", value: 14 },
        { text: "Contabilidade", value: 15 },
        { text: "Contábil", value: 31 },
        { text: "Departamento Pessoal", value: 32 },
        { text: "Compras", value: 33 },
        { text: "Gestão de Carteira", value: 34 },
        { text: "Corporativo", value: 35 },
        { text: "Relacionamento", value: "REL" },
      ],
      relacionamentoSubOptions: [
        { text: "PARQUE DO AGRESTE", value: 19 },
        { text: "PARQUE DAS FLORES", value: 17 },
        { text: "MEMORIAL PARQUE MAEIO", value: 18 },
        { text: "CEMITERIO PREVIDA", value: 20 },
        { text: "PREVIDA", value: 16 },
      ],
      ticSubOptions: [
        { text: "TI", value: 1 },
        { text: "Suporte iVertex", value: 27 },
        { text: "Suporte WK Radar", value: 28 },
        { text: "Gestão TIC", value: 29 },
        { text: "LGPD", value: 30 },
      ],
      entidadeMasterSelecionada: null,
      relacionamentoSubSelecionada: null,
      ticSubSelecionada: null,
      dataInicio: "",
      dataFim: "",
      abertosPorCategoria: [],
      solucionadosFechados: [],
      tempoResolucao: [],
      headersAbertos: [
        { text: "Periodo", value: "periodo" },
        { text: "Categoria", value: "completename" },
        { text: "Quantidade", value: "qtd" },
      ],
      headersSolucionados: [
        { text: "Periodo", value: "periodo" },
        { text: "Quantidade", value: "quantidade" },
      ],
      headersTempo: [
        { text: "Entidade", value: "completename" },
        { text: "Periodo", value: "periodo" },
        { text: "Total de Tickets", value: "totalTicket" },
        { text: "Total de Horas", value: "totalHoras" },
        { text: "Média por Ticket", value: "mediaHorasTickets" },
      ],
      showErrorDias: false,
      dias: 0,
    };
  },
  mounted() {
    // sincroniza entityId inicial com seleção padrão
    this.entityId =
      typeof this.entidadeMasterSelecionada === "number"
        ? this.entidadeMasterSelecionada
        : null;
    this.carregar();
  },
  computed: {
    filteredEmpresas() {
      return this.relacionamentoSubOptions.filter((empresa) =>
        this.hasPermission(empresa.text)
      );
    },
    // listas filtradas pelo período selecionado
    abertosFiltrado() {
      return this.abertosPorCategoria || [];
    },
    solucionadosFiltrado() {
      return this.solucionadosFechados || [];
    },
    tempoFiltrado() {
      return this.tempoResolucao || [];
    },
    resumo() {
      const ab = this.abertosFiltrado;
      const so = this.solucionadosFiltrado;
      const te = this.tempoFiltrado;

      if (!ab.length && !so.length && !te.length) {
        return {
          periodo: null,
          totalChamados: null,
          chamadosSolucionados: null,
          mediaTempoPorTicket: null,
        };
      }

      const periods = [
        ...new Set([
          ...ab.map((x) => x.periodo).filter(Boolean),
          ...so.map((x) => x.periodo).filter(Boolean),
          ...te.map((x) => x.periodo).filter(Boolean),
        ]),
      ];

      let periodoLabel = null;
      if (periods.length) {
        const toKey = (p) => p;
        const minP = periods.reduce((acc, p) =>
          toKey(p) < toKey(acc) ? p : acc
        );
        const maxP = periods.reduce((acc, p) =>
          toKey(p) > toKey(acc) ? p : acc
        );
        periodoLabel = minP === maxP ? maxP : `${minP} - ${maxP}`;
      }

      const totalChamados = ab.reduce(
        (sum, x) => sum + (Number(x.qtd) || 0),
        0
      );
      const chamadosSolucionados = so.reduce(
        (sum, x) => sum + (Number(x.quantidade) || 0),
        0
      );

      let totalTickets = 0;
      let totalSegundos = 0;
      te.forEach((x) => {
        totalTickets += Number(x.totalTicket) || 0;
        totalSegundos += this.parseTimeToSeconds(x.totalHoras || "00:00:00");
      });
      const mediaSegundos =
        totalTickets > 0 ? Math.floor(totalSegundos / totalTickets) : 0;
      const mediaTempoPorTicket =
        totalTickets > 0 ? this.formatSeconds(mediaSegundos) : null;

      return {
        periodo: periodoLabel,
        totalChamados,
        chamadosSolucionados,
        mediaTempoPorTicket,
      };
    },
    chartLabels() {
      const set = new Set(
        [
          ...(this.abertosFiltrado || []).map((x) => x.periodo),
          ...(this.solucionadosFiltrado || []).map((x) => x.periodo),
          ...(this.tempoFiltrado || []).map((x) => x.periodo),
        ].filter(Boolean)
      );
      const arr = Array.from(set);
      return arr;
    },
    formattedChartLabels() {
      return this.chartLabels.map((label) => this.formatPeriodo(label));
    },
    chartSeriesChamados() {
      const labels = this.chartLabels;
      const map = new Map();
      (this.abertosFiltrado || []).forEach((x) => {
        const v = (map.get(x.periodo) || 0) + (Number(x.qtd) || 0);
        map.set(x.periodo, v);
      });
      return [
        {
          name: "Chamados",
          data: labels.map((l) => map.get(l) || 0),
        },
      ];
    },
    chartOptionsChamados() {
      return {
        chart: {
          type: "bar",
          height: 300,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
          },
        },
        colors: ["#4CAF50"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.formattedChartLabels,
        },
        yaxis: {
          title: {
            text: "Quantidade",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " chamados";
            },
          },
        },
      };
    },
    chartSeriesSolucionados() {
      const labels = this.chartLabels;
      const map = new Map();
      (this.solucionadosFiltrado || []).forEach((x) => {
        const v = (map.get(x.periodo) || 0) + (Number(x.quantidade) || 0);
        map.set(x.periodo, v);
      });
      return [
        {
          name: "Solucionados",
          data: labels.map((l) => map.get(l) || 0),
        },
      ];
    },
    chartOptionsSolucionados() {
      return {
        chart: {
          type: "bar",
          height: 300,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
          },
        },
        colors: ["#2196F3"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.formattedChartLabels,
        },
        yaxis: {
          title: {
            text: "Quantidade",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " solucionados";
            },
          },
        },
      };
    },
    chartSeriesTempoResolucao() {
      const labels = this.chartLabels;
      const totalSeg = new Map();
      const totalTk = new Map();
      (this.tempoFiltrado || []).forEach((x) => {
        const seg = this.parseTimeToSeconds(x.totalHoras || "00:00:00");
        const tk = Number(x.totalTicket) || 0;
        totalSeg.set(x.periodo, (totalSeg.get(x.periodo) || 0) + seg);
        totalTk.set(x.periodo, (totalTk.get(x.periodo) || 0) + tk);
      });
      const data = labels.map((l) => {
        const tk = totalTk.get(l) || 0;
        const seg = totalSeg.get(l) || 0;
        const mediaSeg = tk > 0 ? seg / tk : 0;
        return +(mediaSeg / 3600).toFixed(2); // horas
      });
      return [
        {
          name: "Média de horas por ticket",
          data,
        },
      ];
    },
    chartOptionsTempoResolucao() {
      return {
        chart: {
          type: "bar",
          height: 300,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
          },
        },
        colors: ["#FF9800"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.formattedChartLabels,
        },
        yaxis: {
          title: {
            text: "Horas",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " horas";
            },
          },
        },
      };
    },
  },
  watch: {
    entidadeMasterSelecionada(val) {
      if (val === "REL") {
        this.entityId = this.relacionamentoSubSelecionada || null;
        this.ticSubSelecionada = null;
      } else if (val === "TIC") {
        this.entityId = this.ticSubSelecionada || null;
        this.relacionamentoSubSelecionada = null;
      } else {
        this.entityId = val;
        this.relacionamentoSubSelecionada = null;
        this.ticSubSelecionada = null;
      }
    },
    relacionamentoSubSelecionada(val) {
      if (this.entidadeMasterSelecionada === "REL") {
        this.entityId = val || null;
      }
    },
    ticSubSelecionada(val) {
      if (this.entidadeMasterSelecionada === "TIC") {
        this.entityId = val || null;
      }
    },
  },
  methods: {
    formatPeriodo(periodo) {
      if (!periodo || typeof periodo !== "string") return "";
      return periodo.replace("-", "/");
    },

    decodeHtml(html) {
      if (!html || typeof html !== "string") return "";
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },
    onFiltroFiltrar({ dataInicioISO, dataFimISO, entityId }) {
      this.dataInicio = dataInicioISO || "";
      this.dataFim = dataFimISO || "";
      this.entityId = entityId || null;

      if(this.calcularDiferencaEntreDatas(this.dataInicio, this.dataFim) > 180){
        this.showErrorDias = true;
        this.dias = 180;
        return;
      }
      if (this.entityId) {
        this.carregar();
      }
    },
    onFiltroLimpar() {
      this.entityId = null;
    },
    carregar() {
      if (!this.entityId) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      Promise.all([
        Glpi.abertos_por_categoria(
          this.entityId,
          this.dataInicio,
          this.dataFim
        ),
        Glpi.solucionados_fechados(
          this.entityId,
          this.dataInicio,
          this.dataFim
        ),
        Glpi.tempo_resolucao(this.entityId, this.dataInicio, this.dataFim),
      ])
        .then(([abertos, soluc, tempo]) => {
          this.abertosPorCategoria = Array.isArray(abertos.data)
            ? abertos.data
            : [];
          this.solucionadosFechados = Array.isArray(soluc.data)
            ? soluc.data
            : [];
          this.tempoResolucao = Array.isArray(tempo.data) ? tempo.data : [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    parseTimeToSeconds(hhmmss) {
      if (!hhmmss) return 0;
      const [hh = "0", mm = "0", ss = "0"] = String(hhmmss).split(":");
      return (
        (parseInt(hh) || 0) * 3600 +
        (parseInt(mm) || 0) * 60 +
        (parseInt(ss) || 0)
      );
    },
    formatSeconds(totalSeconds) {
      const s = Math.max(0, Math.floor(totalSeconds || 0));
      const hh = String(Math.floor(s / 3600)).padStart(2, "0");
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
      const ss = String(s % 60).padStart(2, "0");
      return `${hh}:${mm}:${ss}`;
    },
    label(k) {
      return k
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },
  },
};
</script>

<style scoped>
.chart-box {
  position: relative;
  width: 100%;
  height: 300px;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
</style>
